import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import { useEffect } from "react";

import liff from "@line/liff";

import { HOME_DIR, VERSION_APP } from "./Utills/constants";

import Theme1Screen from "./Components/Main/Theme1";

function App() {

useEffect(() => {
    document.title = `สุ่มกาชาปอง🎉 ลุ้นรางวัลใหญ่ (v${VERSION_APP})`;
  }, []);


  useEffect(() => {

    liff.ready.then(() => {

    });
  }, []);
  return (
    <Router basename={`${HOME_DIR}`}>
      <Routes>
        <Route exact path="/" element={<Theme1Screen />} />
      </Routes>
    </Router>
  );
}

export default App;
